
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import './App.css';
import Index from './pages/Index';
import OgImageUploadPage from './pages/Admin/OgImageUpload';

// Detail pages for situations
import AbiturientPage from './components/sections/detail-pages/AbiturientPage';
import StudentPage from './components/sections/detail-pages/StudentPage';
import ProfessionalPage from './components/sections/detail-pages/ProfessionalPage';

// Detail pages for coach qualities
import PfarrerPage from './components/sections/detail-pages/PfarrerPage';
import BegleitungPage from './components/sections/detail-pages/BegleitungPage';
import StrategiePage from './components/sections/detail-pages/StrategiePage';
import VisionPage from './components/sections/detail-pages/VisionPage';

// About me related pages
import PreachingPage from './components/sections/detail-pages/PreachingPage';
import MeineLeidenschaften from './components/sections/MeineLeidenschaften';
import SommerCamps2025Page from './components/sections/detail-pages/SommerCamps2025Page';
import SommerCampsInfoPage from './components/sections/detail-pages/SommerCampsInfoPage';
import KompassCampsPage from './components/sections/detail-pages/KompassCampsPage';
import DerRichtigeCoachPage from './components/sections/detail-pages/DerRichtigeCoachPage';

// New meta tag page
import MetaTagPage from './pages/Admin/MetaTagPage';

// These should be replaced with the actual components when they're available
const Impressum = () => <div className="min-h-screen bg-slate-100 p-8"><h1 className="text-3xl font-bold mb-4">Impressum</h1><p>Impressum Page - Inhalt wird bald hinzugefügt</p></div>;
const Datenschutz = () => <div className="min-h-screen bg-slate-100 p-8"><h1 className="text-3xl font-bold mb-4">Datenschutz</h1><p>Datenschutz Page - Inhalt wird bald hinzugefügt</p></div>;

// Admin page that redirects to home with admin section visible
const Admin = () => {
  return <Navigate to="/" replace />;
};

// Catch-all error page
const ErrorPage = () => (
  <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center p-4">
    <h1 className="text-3xl font-bold mb-4">Seite nicht gefunden</h1>
    <p className="mb-6">Die angeforderte Seite existiert nicht.</p>
    <a href="/" className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
      Zurück zur Startseite
    </a>
  </div>
);

// Image upload
import { ImageUpload } from './components/admin/ImageUpload';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        
        {/* Situation detail pages */}
        <Route path="/abiturient" element={<AbiturientPage />} />
        <Route path="/student" element={<StudentPage />} />
        <Route path="/professional" element={<ProfessionalPage />} />
        
        {/* Coach qualities detail pages */}
        <Route path="/pfarrer" element={<PfarrerPage />} />
        <Route path="/begleitung" element={<BegleitungPage />} />
        <Route path="/strategie" element={<StrategiePage />} />
        <Route path="/vision" element={<VisionPage />} />
        
        {/* About me related pages */}
        <Route path="/preaching" element={<PreachingPage />} />
        <Route path="/passions" element={<MeineLeidenschaften />} />
        <Route path="/kompass-camps" element={<KompassCampsPage />} />
        <Route path="/kurzueberblick" element={<SommerCamps2025Page />} />
        <Route path="/alle-infos" element={<SommerCampsInfoPage />} />
        <Route path="/der-richtige-coach" element={<DerRichtigeCoachPage />} />
        
        {/* Legal pages */}
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        
        {/* Admin routes */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/og-image-upload" element={<OgImageUploadPage />} />
        <Route path="/admin/image-upload" element={<ImageUpload />} />
        <Route path="/admin/meta-tags" element={<MetaTagPage />} />
        
        {/* Catch-all route */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      
      <Toaster />
    </Router>
  );
}

export default App;
